import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["test-cms-page-id"]
const _hoisted_3 = { class: "library-link-content" }
const _hoisted_4 = { class: "activity-button-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "activity-button-inner" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "activity-description" }

import { computed } from "vue";

import { type DayOrPageType } from "../../services/cms/cms-type-definitions";


export default /*#__PURE__*/_defineComponent({
  __name: 'library-item-link',
  props: {
    activityId: {},
    pageId: {},
    pageUid: {},
    dayOrPageType: {}
  },
  setup(__props: any) {

const props = __props;

const backgroundImageFileName = computed(() => {
  if (props.dayOrPageType === "journal") {
    return "journal-pink.svg";
  }

  if (props.dayOrPageType === "library") {
    return "book-pink.svg";
  }

  return null;
});

const backgroundImage = computed(() => {
  return backgroundImageFileName.value
    ? `url(/content/images/develop/day-graphics/${backgroundImageFileName.value})`
    : "none";
});

const libraryLink = computed(() => {
  return `/resources/develop/${props.pageUid}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "a-no-highlight",
    href: libraryLink.value
  }, [
    _createElementVNode("div", {
      class: "library-item-link activity activity-with-button",
      "test-cms-page-id": _ctx.pageId
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "activity-button",
            style: _normalizeStyle({
              backgroundImage: backgroundImage.value,
              backgroundSize: '60%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            })
          }, _hoisted_6, 4)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ], 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})